import {React} from 'react';

import {Link} from "react-router-dom";
import RevealLinks from './links';
import { ButtonDrawOutline } from '../../components/common';

const Contact = () => {
    return(
        <div>
            <section>

                <img src={require("../../assets/img/inserr/IMG_5221_crop.JPG")} alt="INSERR" class="h-1/2" style={{objectFit:"cover", overflow: "cover"}} />

                <h1 class="text-5xl  w-screen text-center p-10">Get in touch with our team</h1>

                <div class="lg:flex items-center  justify-center p-10 m-10">
                    <div class="lg:w-1/2 lg:float-left lg:pl-5 lg:ml-5">
                    <h3 class="text-2xl font-bold mb-1">Investement Inquiry</h3>
                    <p class="text-xl text-gray-500 mb-5">Julio@macanista.com</p>
                    <h3 class="text-2xl font-bold mb-1">Sales Inquiry</h3>
                    <p class="text-xl text-gray-500 mb-5">sales@macanista.com</p>
                    <h3 class="text-2xl font-bold ">Follow Us On</h3>
                    <div class="flex items-center ">
                    <RevealLinks />
                    </div>
                    </div>
                    <div class="lg:w-1/2 lg:float-right lg:pr-5 lg:mr-5">

                    <h2 class="text-4xl font-bold p-5">Start your journey with INSERR</h2>
                    <p class="text-xl py-5 lg:px-5 text-gray-500">
                        INSERR is a groundbreaking Remotely Operated Vehicle (ROV) engineered to revolutionize underwater rescue operations. Designed for zero-visibility environments, INSERR combines advanced navigation systems with life-sustaining equipment to enhance disaster response and save lives.
                    </p>
                    </div>

                </div>

                <div class="w-screen mt-40 justify-center flex mb-40  box-sizing">
                    <div class="w-[90vw] lg:w-3/5 h-auto lg:h-[40vh]  justify-center flex  box-sizing">
                        <div class="h-full w-screen bg-gradient-to-r from-green-500 to-teal-900 text-white">
    
                            <div class="p-5 mt-5">
                                <h2 class=" text-5xl lg:text-6xl m-5 font-semibold">Not sure about INSERR?</h2>
                                <p class="m-5 text-xl text-justify">
                                At Macanista Robotics, our vision is to revolutionize robotics by developing innovative technology solutions that enhance safety, efficiency, and exploration across various industries. We are committed to pushing the boundaries of technology to address complex challenges in marine environments, ensuring a sustainable and prosperous future for our planet. 
                                </p>
                                <Link to={"/inserr"} class="text-center font-semibold hover:text-black py-2 px-4 ">
                                    <ButtonDrawOutline>Learn More About INSERR →</ButtonDrawOutline>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Contact;